import { AxiosError } from 'axios';
import { t } from 'i18next';
import { useState } from 'react';

import Modal from '../../../../../components/Modal';
import {
  backendErrorNotification,
  frontendNotification,
} from '../../../../../components/Notification';
import HttpStatus from '../../../../../enums/httpStatus';
import { superContactsReq } from '../../../../../services/requests';
import { Contact } from '../../../../../types/apiResponse/contact';

type Props = {
  showModal: boolean;
  selectedItem: Contact;
  closeModal: () => void;
  callback: () => void;
};

const DeleteContactModal = ({ showModal, selectedItem, closeModal, callback }: Props) => {
  const [isLoading, setIsLoading] = useState(false);

  const saveRequest = async () => {
    setIsLoading(true);
    try {
      superContactsReq.query = '';
      const res = await superContactsReq.delete(selectedItem.id);

      if (res.status !== HttpStatus.OK) {
        throw res;
      }

      frontendNotification({
        message: t('successfullyDeleted'),
        type: 'success',
      });

      callback();
      closeModal();
    } catch (err) {
      if (!superContactsReq.axios.isCancel(err)) {
        backendErrorNotification(err as AxiosError<any, any>);
      }
    }

    setIsLoading(false);
  };

  return (
    <Modal
      action={() => saveRequest()}
      isLoading={isLoading}
      closeModal={closeModal}
      cancelButton={closeModal}
      bodyStyle={{ overflowX: 'scroll' }}
      title={t('delete')}
      showModal={showModal}
      actionNameBtn={t('confirm')}
    >
      <div>{t('deleteSure') as string}?</div>
      <div>
        {t('id') as string}: {selectedItem.id}
      </div>
      <div>
        {t('contact') as string}: {selectedItem.contact}
      </div>
      <div>
        {t('sector') as string}: {selectedItem.sector}
      </div>
    </Modal>
  );
};

export default DeleteContactModal;
